import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=63e06455&scoped=true&"
import script from "./findPwd.vue?vue&type=script&lang=js&"
export * from "./findPwd.vue?vue&type=script&lang=js&"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=63e06455&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e06455",
  null
  
)

export default component.exports